export default class DrillDownLink {
  constructor(report, dateField, params) {
    this.report = report;
    this.dateField = dateField;
    this.params = params;
  }
}
